import { roundToRoundingPoint } from "../math-service.js";
import { FieldAdapter } from "./FieldAdapter";
import type { ActivityTriggerFieldId } from "./types";

interface CoordinateActivityTriggerField {
	Id: ActivityTriggerFieldId;
	RoundingPoint?: number;
}

export interface CoordinateFieldValue {
	FieldId: ActivityTriggerFieldId;
	Latitude: number;
	Longitude: number;
}

export class CoordinateFieldAdapter extends FieldAdapter<CoordinateFieldValue> {
	constructor(
		field: CoordinateActivityTriggerField,
		hasValue: () => boolean,
		onTriggered: (value: CoordinateFieldValue) => void
	) {
		super({
			hasValue,
			resolveValue: async capture => {
				const position = await capture.getCurrentPosition();
				return {
					FieldId: field.Id,
					Latitude: roundToRoundingPoint(position.latitude, field),
					Longitude: roundToRoundingPoint(position.longitude, field)
				};
			},
			onTriggered
		});
	}
}
